import PiSwitch from "../../../components/PiSwitch";
import PiNumberProperty from "../../../components/PiProperties/PiNumberProperty";
import {
  setAnimateActorLayer,
  type IAnimateActor,
} from "../../../models/AnimateActor";
import { InteractionPropertyType } from "../../../models/InteractionProperty";
import type { InteractionPropertiesEditor } from "../../interaction_factory/InteractionFactory";

export const AnimateActorPropertiesEditor: InteractionPropertiesEditor = {
  render: (interaction, actions) => {
    const animateActor = interaction as IAnimateActor;
    const updateAnimateActor = (updatedInteraction: IAnimateActor) => {
      actions.updateInteraction(updatedInteraction);
    };

    return (
      <>
        <PiNumberProperty
          interactionProperty={{
            id: "layer",
            name: "Layer",
            type: InteractionPropertyType.number,
            value: animateActor.layer,
          }}
          onChange={(property) =>
            // state + layer define the animation, so the id is re-derived
            updateAnimateActor(setAnimateActorLayer(animateActor, property.value))
          }
        />
        <PiNumberProperty
          interactionProperty={{
            id: "transitionTime",
            name: "Transition Time",
            type: InteractionPropertyType.number,
            value: animateActor.transitionTime,
          }}
          onChange={(property) =>
            updateAnimateActor({
              ...animateActor,
              transitionTime: property.value,
            })
          }
        />
        <PiSwitch
          label="Wait until finished"
          checked={animateActor.waitUntilFinished}
          onChange={(waitUntilFinished) =>
            updateAnimateActor({
              ...animateActor,
              waitUntilFinished,
            })
          }
        />
      </>
    );
  },
};
